export const getUrlParams = (url = window.location.href) => {
  const vars = {};
  url.replace(/[?&]+([^=&]+)=([^&#]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars;
};
